import React from 'react'
import style from './style.css'
export default props => (
    <div>
        <div style={{
            ...props.style
        }}
        className={`${style.contentPlaceholder} ${style[props.type]}`}>
            <br />
        </div>

    </div>
)


// WEBPACK FOOTER //
// ./src/components/atoms/PlaceHolder/index.js